import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OhayoLocaleModule } from '@ohayojp.com/theme';
import { OhayoUtilModule } from '@ohayojp.com/util';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { TagSelectComponent } from './tag-select.component';

const COMPONENTS = [TagSelectComponent];

@NgModule({
  imports: [CommonModule, NzIconModule, OhayoLocaleModule, OhayoUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class TagSelectModule { }
